var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-compass"},[_c('IconCompass',{style:({transform: ("rotate(" + (_vm.compass.degree) + "deg)")}),attrs:{"class-name":"visual-compass__svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }